module.exports = {"username":"Username","password":"Password","login":"Log in","errors":{"username-required":"Username is required and cannot be left blank","password-required":"Password is required and cannot be left blank","4c6e7474-1892-43f3-baf9-b8a8b9ea2be5":"Username or password not found"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/login-form.json
// module id = ONO+
// module chunks = 1